import { Component, OnInit, Input } from '@angular/core';
import { PrismicService } from 'src/app/_services/prismic.service';

@Component({
  selector: 'app-component-subtitle',
  standalone: false,
  templateUrl: './subtitle.component.html',
  styleUrls: ['./subtitle.component.scss']
})
export class SubtitleComponent implements OnInit {

  @Input() public component: any;
  @Input() public text_color: any;
  @Input('vehicleObject') public vehicle: any;

  constructor(private prismicService: PrismicService) { }

  ngOnInit() {
  }


  getHtml(content, vehicleObject) {
    return this.prismicService.getHtml(content, vehicleObject);
  }

}
